<template>
  <div class="navBar">
    <div class="mainContainer flex_space">
      <!--中间menu-->
      <div class="gw_navBarmenu flex">
        <!--logo-->
        <div class="gw_logo flex_align">
          <img src="../assets/logo.png" alt="">
        </div>
        <el-menu mode="horizontal" :default-active="$route.path" router  text-color="#fff" background-color="#2A303B"
                 active-text-color="#ffd04b" @select="selectMenu">
          <el-menu-item index="/home">
            首页
          </el-menu-item>
          <el-submenu index="/product1">
            <template slot="title">产品服务</template>
            <el-menu-item index="/product1">漏洞扫描</el-menu-item>
            <!--<el-menu-item index="/product2">渗透测试</el-menu-item>-->
            <el-menu-item index="/product3">专家服务</el-menu-item>
            <!--<el-menu-item index="/product4">牛盾云</el-menu-item>-->
          </el-submenu>
          <el-submenu index="/solution1">
            <template slot="title">解决方案</template>
            <el-menu-item index="/solution1">未备案域名阻断系统</el-menu-item>
            <el-menu-item index="/solution2">网站全时安全管控平台</el-menu-item>
            <el-menu-item index="/solution3">一物一码品牌防伪</el-menu-item>
          </el-submenu>
          <el-menu-item index="">
            <a class="goNews" href="https://www.newdun.com/news/">新闻中心</a>
          </el-menu-item>
          <el-menu-item index="/client">
            客户案例
          </el-menu-item>
          <el-menu-item index="/aboutUs">
            关于我们
          </el-menu-item>
          <el-menu-item index="/mySite" class="R_Site" v-show="isLogin">
            我的网站
          </el-menu-item>
        </el-menu>
      </div>
      <!--右边登录按钮-->
      <!--<div class="gw_loginBox" v-if="!isLogin">
        <span class="login" @click="dialogLoginVisible = true">登录</span>
        <span class="gw_register" @click="dialogRegisterVisible = true">注册</span>
      </div>
      <!--右边（登录过后）用户信息-->
      <div class="gw_user" v-else>
        <div class="title_user" @mouseover="openUserBox(true)" ><i class="iconUser"></i><i class="el-icon-caret-bottom"></i></div>
        <!--窗口-->
        <div class="pop_user" v-show="UserBox" @mouseleave="openUserBox(false)">
          <ul class="flexCol_aroud">
            <li class="flex_between"><span>
              <i class="icon icon_mobile"></i>手机： {{user_mobile == null ? "" : user_mobile}}</span>
              <a v-if="!user_mobile" @click="bind_phoneVisible = true">绑定</a>
              <a v-else @click="fix_PhoneVisible = true">修改</a>
            </li>
            <li class="flex_between">
              <span><i class="icon icon_pwd"></i>密码： ******</span>
              <a @click="fix_pwdVisible = true">修改</a>
            </li>
            <li class="flex_between">
              <span><i class="icon icon_email"></i>邮箱： {{user_email == null ? "" : user_email}}</span>
              <a v-if="!user_email" @click="bind_emailVisible = true">绑定</a>
              <a v-else @click="fix_emailVisible = true">修改</a>
            </li>
            <li class="lastLi">
              <el-button class="return_btn" @click="logoutClick">退出</el-button>
            </li>
          </ul>
        </div>
      </div>-->
      <!--弹窗：注册-->
      <el-dialog class="dialog_register" :visible.sync="dialogRegisterVisible"
                 :modal-append-to-body="false"  width="500px" :close-on-click-modal="false" @close="closeClick('ruleForm_register')">
        <el-form :model="formRegister" :rules="rules_register" ref="ruleForm_register">
          <p class="h_title">注册</p>
          <el-form-item class="item1" prop="mobile">
            <el-input v-model="formRegister.mobile" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item class="item2" prop="sms_code">
            <el-input v-model="formRegister.sms_code" placeholder="请输入短信验证码"></el-input>
            <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_register" @click="getCodeCom(formRegister.mobile,'getCodeValue1','codeActive_register')">{{getcodeTxtObj.getCodeValue1}}</el-button>
          </el-form-item>
          <el-form-item class="item3" prop="password">
            <el-input  v-model="formRegister.password" placeholder="请设置登录密码" type="password"></el-input>
          </el-form-item>
          <el-form-item class="item4">
            <el-checkbox v-model="isChecked"></el-checkbox>
            <span class="read">阅读并接受<a @click="goAgreenment">《牛盾用户协议》 </a></span>
          </el-form-item>
        </el-form>
        <el-button :disabled="registerBtn" type="primary" class="button_register" @click="registerr('ruleForm_register')">注册</el-button>
        <div class="item_bot">已有账号？<a @click="goLogin('formRegister')">立即登录</a></div>
      </el-dialog>
      <!--弹窗：登录(账号密码)-->
      <el-dialog class="dialog_register dialog_login" :visible.sync="dialogLoginVisible"
                 :modal-append-to-body="false" width="500px" :close-on-click-modal="false" @close="closeClick('ruleForm_login')">
        <el-form :model="formLogin" :rules="rules_login" ref="ruleForm_login">
          <p class="h_title">登录</p>
          <el-form-item class="item1" prop="value">
            <el-input v-model="formLogin.value" placeholder="手机号/邮箱"></el-input>
          </el-form-item>
          <el-form-item class="item3" prop="password">
            <el-input v-model="formLogin.password" placeholder="密码" type="password"></el-input>
          </el-form-item>
        </el-form>
        <el-button class="button_register" @click="Loginn('ruleForm_login')">登录</el-button>
        <div class="flex_between">
          <div class="item_bot">还没有账号？<a @click="goRegister">免费注册</a></div>
          <div class="bot_rt" @click="goLoginPhone('formLogin')">快捷登录</div>
        </div>
      </el-dialog>
      <!--弹窗：登录(手机号) -->
      <el-dialog class="dialog_register" :visible.sync="dialogLoginPhoneVisible" :close-on-click-modal="false"
                 :modal-append-to-body="false" width="500px" @close="closeClick('rules_loginPhone')">
        <el-form :model="formLoginPhone" :rules="rules_loginPhone" ref="rules_loginPhone">
          <p class="h_title">登录</p>
          <el-form-item class="item1" prop="mobile">
            <el-input v-model="formLoginPhone.mobile" placeholder="手机号"></el-input>
          </el-form-item>
          <el-form-item class="item2" prop="code">
            <el-input v-model="formLoginPhone.code" placeholder="验证码"></el-input>
            <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_login" @click="getCodeCom(formLoginPhone.mobile,'getCodeValue','codeActive_login')" >{{getcodeTxtObj.getCodeValue}}</el-button>
          </el-form-item>
        </el-form>
        <el-button class="button_register" @click="LoginMobilee('rules_loginPhone')">登录</el-button>
        <div class="flex_between">
          <div class="item_bot">还没有账号？<a @click="goRegister('formLoginPhone')">免费注册</a></div>
          <div class="bot_rt" @click="goLoginPwd('formLoginPhone')">账号登录</div>
        </div>
      </el-dialog>
    </div>

    <!--修改手机号--验证-->
    <el-dialog class="fix_phone" :visible.sync="fix_PhoneVisible" width="560px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="fix_PhoneForm">
        <h4 class="h_title">身份验证</h4>
        <div class="box_item wrap"><i class="icon_info el-icon-warning"></i>为了您的账号安全，进行敏感操作前须先验证身份</div>
        <p class="box_item"><label>验证方式</label> 手机验证</p>
        <p class="box_item"><label>绑定手机</label> {{user_mobile}}</p>
        <el-form-item class="item2" prop="sms_code" label="验证码">
          <el-input v-model="fix_PhoneForm.sms_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_fixPhone" @click="getCodeCom(user_mobile,'getCode_fixPhoneValue','codeActive_fixPhone')">{{getcodeTxtObj.getCode_fixPhoneValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
          <el-button type="primary" @click="fix_PhoneClick(user_mobile,fix_PhoneForm.sms_code)">确 定</el-button>
          <el-button  @click="fix_PhoneVisible = false">取 消</el-button>
        </span>
    </el-dialog>
    <!--修改邮箱--验证 -->
    <el-dialog class="fix_phone" :visible.sync="fix_emailVisible" width="560px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="fix_EmailForm">
        <h4 class="h_title">身份验证</h4>
        <div class="box_item wrap"><i class="icon_info el-icon-warning"></i>为了您的账号安全，进行敏感操作前须先验证身份</div>
        <p class="box_item"><label>验证方式</label> 邮箱验证</p>
        <p class="box_item"><label>绑定邮箱</label> {{user_email}}</p>
        <el-form-item class="item2" prop="email_code" label="验证码">
          <el-input v-model="fix_EmailForm.email_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_fixEmail"  @click="getCodeCom_email(user_email,'getCode_fixEmailValue','codeActive_fixEmail')">{{getcodeTxtObj.getCode_fixEmailValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
          <el-button type="primary"  @click="fix_EmailClick(user_email,fix_EmailForm.email_code)">确 定</el-button>
          <el-button  @click="fix_emailVisible = false">取 消</el-button>
        </span>
    </el-dialog>
    <!--修改成新手机号-->
    <el-dialog class="fix_phone fix_pwd" :visible.sync="fix_phoneNewVisible" width="500px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="fix_phoneNew">
        <h4 class="h_title">修改手机</h4>
        <el-form-item class="item1" prop="new_mobile">
          <el-input v-model="fix_phoneNew.new_mobile" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item class="item2" prop="sms_code">
          <el-input v-model="fix_phoneNew.sms_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_fixPhoneNew" @click="getCodeCom(fix_phoneNew.new_mobile,'getCode_fixPhoneNewValue','codeActive_fixPhoneNew')">{{getcodeTxtObj.getCode_fixPhoneNewValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
        <el-button class="bigBtn" type="primary" @click="fix_phoneNewClick(fix_phoneNew.new_mobile,fix_phoneNew.sms_code)">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改成新邮箱 -->
    <el-dialog class="fix_phone fix_pwd" :visible.sync="fix_emailNewVisible" width="500px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="fix_emailNew">
        <h4 class="h_title">修改邮箱</h4>
        <el-form-item class="item1" prop="new_email">
          <el-input v-model="fix_emailNew.new_email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item class="item2" prop="email_code">
          <el-input v-model="fix_emailNew.email_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_fixEmailNew" @click="getCodeCom_email(fix_emailNew.new_email,'getCode_fixEmailNewValue','codeActive_fixEmailNew')">{{getcodeTxtObj.getCode_fixEmailNewValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
        <el-button class="bigBtn" type="primary" @click="fix_emailNewClick(fix_emailNew.new_email,fix_emailNew.email_code)">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改密码-->
    <el-dialog class="fix_phone fix_pwd" :visible.sync="fix_pwdVisible" width="560px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="fix_pwd" >
        <h4 class="h_title">更改密码</h4>
        <p class="box_item">您的手机号码是： {{user_mobile}}</p>
        <el-form-item class="item2" prop="sms_code" label="验证码">
          <el-input v-model="fix_pwd.sms_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_fixPwd" @click="getCodeCom(user_mobile,'getCodePwdValue','codeActive_fixPwd')">{{getcodeTxtObj.getCodePwdValue}}</el-button>
        </el-form-item>
        <el-form-item class="item1" prop="new_password" label="用户新密码">
          <el-input v-model="fix_pwd.new_password" placeholder="密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
        <el-button class="bigBtn" type="primary" @click="fix_pwdClick(user_mobile,fix_pwd.sms_code,fix_pwd.new_password)">确 定</el-button>
      </span>
    </el-dialog>
    <!--绑定邮箱-->
    <el-dialog class="fix_phone fix_pwd" :visible.sync="bind_emailVisible" width="500px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="bind_email" >
        <h4 class="h_title">邮箱绑定</h4>
        <el-form-item class="item1" prop="email">
          <el-input v-model="bind_email.email" placeholder="邮箱账号"></el-input>
        </el-form-item>
        <el-form-item class="item2" prop="email_code">
          <el-input v-model="bind_email.email_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_bindEmail" @click="getCodeCom_email(bind_email.email,'getCodeEmailValue','codeActive_bindEmail')">{{getcodeTxtObj.getCodeEmailValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
        <el-button class="bigBtn" type="primary" @click="bind_emailClick(bind_email.email,bind_email.email_code)">确 定</el-button>
      </span>
    </el-dialog>
    <!--绑定手机号-->
    <el-dialog class="fix_phone fix_pwd" :visible.sync="bind_phoneVisible" width="500px" :close-on-click-modal="false" :modal-append-to-body="false">
      <el-form :model="bind_phone"  >
        <h4 class="h_title">手机号绑定</h4>
        <el-form-item class="item1" prop="mobile">
          <el-input v-model="bind_phone.mobile" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item class="item2" prop="sms_code">
          <el-input v-model="bind_phone.sms_code" placeholder="验证码"></el-input>
          <el-button type="primary" class="button_vCode" :disabled="getCodeActiveObj.codeActive_bindPhone" @click="getCodeCom(bind_phone.mobile,'getCodephoneValue','codeActive_bindPhone')">{{getcodeTxtObj.getCodephoneValue}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex_center">
        <el-button class="bigBtn" type="primary" @click="bind_PhoneClick(bind_phone.mobile,bind_phone.sms_code)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {login,loginMobile,register,sms_code,logout,check_mobile,reset_mobile,pass_info,email_code,set_email,set_mobile,reset_email,check_email} from '../api/api'
  export default {
    name: "Navbar",
    data() {
      return {
        ids:'',
        user_mobile:'',
        user_email:'',
        UserBox:false,//下拉框是否显示
        registerBtn:false,
        getCodeValue:"获取验证码",
        getCodeValue1:"获取验证码",
        getCode_fixPhoneValue:"获取验证码",
        getCode_fixPhoneNewValue:"获取验证码",
        getcodeTxtObj:{
          getCodePwdValue:'获取验证码',
          getCodeValue:'获取验证码',
          getCodeValue1:"获取验证码",
          getCode_fixPhoneValue:"获取验证码",
          getCode_fixEmailValue:"获取验证码",
          getCode_fixPhoneNewValue:"获取验证码",
          getCode_fixEmailNewValue:"获取验证码",
          getCodeEmailValue:"获取验证码",
          getCodephoneValue:"获取验证码",
        },
        getCodeActiveObj:{
          codeActive_login:false,
          codeActive_register:false,
          codeActive_fixPhone:false,
          codeActive_fixPhoneNew:false,
          codeActive_fixEmailNew:false,
          codeActive_fixPwd:false,
          codeActive_bindEmail:false,
          codeActive_fixEmail:false,
          codeActive_bindPhone:false,
        },
        bind_emailVisible: false,//绑定邮箱
        bind_phoneVisible: false,//绑定手机
        fix_PhoneVisible: false,
        fix_phoneNewVisible: false,
        fix_emailNewVisible: false,
        fix_emailVisible: false,
        fix_pwdVisible: false,
        isLogin: false,//是否登录
        isContactDialog: false,
        isChecked: true,//是否勾选
        dialogLoginVisible: false,//账号框
        dialogLoginPhoneVisible: false,//手机登录框
        dialogRegisterVisible: false,
        fix_PhoneForm: {
          mobile: '',
          code: '',
        },
        fix_EmailForm: {
          email: '',
          email_code: '',
        },
        bind_email: {
          email: '',
          email_code: '',
        },
        fix_phoneNew: {
          new_mobile: '',
          sms_code: '',
        },
        fix_emailNew: {
          new_email: '',
          email_code: '',
        },
        bind_phone: {//
          mobile: '',
          sms_code: '',
        },
        fix_pwd: {
          mobile: '',
          sms_code: '',
          new_password: '',
        },
        formLogin: {//账号密码登录
          value: '',
          password: '',
        },
        formLoginPhone: {//手机号登录
          mobile: '',
          code: '',
        },
        formRegister: {
          mobile: '',
          sms_code: '',
          password: '',
        },
        rules_login: {
          value: [
            {required: true, message: '手机号/邮箱不能为空', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'},
          ],
        },
        rules_loginPhone: {
          mobile: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码输入有误，请重新输入', trigger: 'blur'}
          ],
          code: [
            {required: true, message: '验证码不能为空', trigger: 'blur'},
          ],
        },
        rules_register: {
          mobile: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {pattern: /^[1][3,4,5,7,8][0-9]{9}$/, message: '手机号码输入有误', trigger: 'blur'}
          ],
          sms_code: [
            {required: true, message: '验证码不能为空', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请设置您的登录密码', trigger: 'blur'},
            {pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/, message: '密码为长度在6-18位之间的数组字母组合', trigger: 'blur'}
          ],
        },
      }
    },
    mounted(){
      this.checkIsLogin();
      this.$bus.$on('login',this.buslogin);
    },
    beforeDestroy(){
      this.$bus.$off('login',this.buslogin);
    },
    methods: {
      buslogin(){
        this.dialogLoginVisible = true;
      },
      closeClick(formName){//清空form
          this.$refs[formName].resetFields();
      },
      selectMenu(){
        window.scrollTo({top:0});
      },
      // 判断是否登录
      checkIsLogin(){
        console.log('navbar-------');
        let cookieKey = document.cookie.indexOf('SESSIONIDND=');
        if(cookieKey==-1){
          //未登录
          this.isLogin = false;
        }else{
          //登录
          this.isLogin = true;
          this.user_mobile = window.localStorage.getItem('user_mobile');
          console.log('this.user_mobile :',this.user_mobile);
          this.ids = window.localStorage.getItem('ids');
         // console.log('this.user_email',this.user_email);
          let userEmail= window.localStorage.getItem('user_email');
          if(userEmail){//
            this.user_email= window.localStorage.getItem('user_email');
          }else{//有邮箱时
            this.user_email = "";
          }
        }
      },
      //倒计时
      getTimer(mobile,value,isCodeActive){
        let vm = this;
        let num = 59;
        vm.getCodeActiveObj[isCodeActive] = true;//倒计时禁用
        vm.getcodeTxtObj[value] = num + "s";
        let timer = setInterval(function(){
          num--; vm.getcodeTxtObj[value] = num + "s";
          if(num <= 0){
            vm.getCodeActiveObj[isCodeActive] = false;
            clearInterval(timer); vm.getcodeTxtObj[value] = "获取验证码"
          }
        },1000);
      },
      //发送验证码-手机号
      getCodeCom(mobile,value,isCodeActive){
        let vm = this;
        if(/^1[34578]\d{9}$/.test(mobile) || /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(mobile)){//验证手机或者邮箱 //
          let params ={mobile:mobile};
          sms_code(params).then(res=>{
            if(res.data.code == '00'){ //succ
              vm.getTimer(mobile,value,isCodeActive);//获取验证码
             // vm.$message({type:'success', message:res.data.msg,});
            }else{//err
              vm.$message({type:'error', message:res.data.message,})
            }
          })
        }else{
          //vm.$message({type: 'error', message: '手机号码有误jjj!'});
        }
      },
      //发送验证码-邮箱
      getCodeCom_email(email,value,isCodeActive){
        let vm = this;
        if(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email)){//验证手机或者邮箱 //
          vm.getTimer(email,value,isCodeActive);
          let params ={email:email};
          email_code(params).then(res=>{
            if(res.data.code == '1'){ //succ
              vm.$message({type:'success', message:res.data.message,});
            }else{//err
              vm.$message({type:'error', message:res.data.message,})
            }
          })
        }else{
          //vm.$message({type: 'error', message: '邮箱格式有误!'});
        }
      },
      Loginn(formName) {//提交登录信息-账号
        this.$refs[formName].validate((valid) => {
          if (valid) {//通过验证
            let vm = this;
            login(vm.formLogin).then(res => {
              if(res.data.code == 1){//succ
                this.user_mobile = res.data.mobile;
                this.ids = res.data.user_id;
                this.user_email = res.data.email;
                window.localStorage.setItem('user_mobile',vm.user_mobile);
                if(this.user_email){window.localStorage.setItem('user_email',vm.user_email);}
                window.localStorage.setItem('ids',vm.ids);
                vm.$message({type:'success', message:res.data.message,});
                vm.dialogLoginVisible = false;
                vm.dialogLoginPhoneVisible = false;
                vm.isLogin = true;
                vm.formLogin = {};
                vm.$refs[formName].resetFields();
              }else{//err
                vm.$message({type:'error', message:res.data.message,})
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      LoginMobilee(formName) {//提交登录信息-手机号
        this.$refs[formName].validate((valid) => {
          if (valid) {//通过验证
            let vm = this;
            loginMobile({mobile:vm.formLoginPhone.mobile,code:vm.formLoginPhone.code}).then(res => {
              if(res.data.code == 1){//succ
                this.user_mobile = res.data.mobile;
                this.ids = res.data.user_id;
                this.user_email = res.data.email;
                window.localStorage.setItem('user_mobile',vm.user_mobile);
                if(this.user_email){window.localStorage.setItem('user_email',vm.user_email);}
                window.localStorage.setItem('ids',vm.ids);
                vm.$message({type:'success', message:res.data.message,});
                vm.dialogLoginPhoneVisible = false;
                vm.isLogin = true;
                vm.formLoginPhone = {};
              }else{//err
                vm.$message({type:'error', message:res.data.message,})
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      registerr(formName) { //提交注册信息
        let vm = this;
        if(!vm.isChecked){
          vm.$message({type:'error', message:"请阅读并接受《牛盾用户协议》",});
          return false;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {//通过验证
            let params ={
              mobile:this.formRegister.mobile,
              sms_code: this.formRegister.sms_code,
              password: this.formRegister.password,
            };
            register(params).then(res=>{
              if(res.data.code == 1){//succ
                vm.$message({type:'success', message:res.data.message,});
                vm.dialogRegisterVisible = false;
                vm.dialogLoginVisible = true;
                vm.formRegister = {};
              }else{//err
                vm.$message({type:'error', message:res.data.message,})
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      fix_PhoneClick(mobile,sms_code){//验证--手机号
        let vm = this;
        check_mobile({mobile:mobile,sms_code:sms_code}).then(res => {
          if(res.data.code == 1){//succ
            //vm.$message({type:'success', message:res.data.message,});
            vm.fix_PhoneVisible = false;
            vm.fix_phoneNewVisible = true;
            vm.fix_PhoneForm ={};
          }else{//err
            vm.$message({type:'error', message:res.data.message,})
          }
        })
      },
      fix_EmailClick(email,email_code){//验证--邮箱
        let vm = this;
        check_email({email:email,email_code:email_code}).then(res => {
          if(res.data.code == 1){//succ
            //vm.$message({type:'success', message:res.data.message,});
            vm.fix_emailVisible = false;
            vm.fix_emailNewVisible = true;
            vm.fix_EmailForm = {};
          }else{//err
            vm.$message({type:'error', message:res.data.message,})
          }
        })
      },
      fix_phoneNewClick(mobile,sms_code){//绑定新手机号--手机号
        let vm = this;
        reset_mobile({id:vm.ids,new_mobile:mobile,sms_code:sms_code}).then(res => {
          if(res.data.code == 1){//succ
            vm.$message({type:'success', message:res.data.message,});
            vm.fix_phoneNewVisible = false;
            vm.user_mobile = vm.fix_phoneNew.new_mobile;
            vm.fix_phoneNew = {};
            window.localStorage.setItem('user_mobile',vm.user_mobile);
          }else{//err
            vm.$message({type:'error', message:res.data.message,})
          }
        })
      },
      fix_emailNewClick(email,email_code){//用户修改绑定邮箱--邮箱
        let vm = this;
        reset_email({id:vm.ids,new_email:email,email_code:email_code}).then(res => {
          if(res.data.code == 1){//succ
            vm.$message({type:'success', message:res.data.message,});
            vm.fix_emailNewVisible = false;
            vm.user_email = email;
            vm.fix_emailNew = {};
            window.localStorage.setItem('user_email',vm.user_email);
          }else{//err
            vm.$message({type:'error', message:res.data.message,})
          }
        })
      },
      fix_pwdClick(mobile,code,pwd){ //修改密码-确定
        let vm = this;
        pass_info({mobile:mobile,sms_code:code,new_password:pwd}).then(res => {
          if(res.data.code == 1){//succ
            vm.$message({type:'success', message:res.data.message,});
            vm.fix_pwdVisible = false;
            vm.fix_pwd = {};
          }else{//err
            vm.$message({type:'error', message:res.data.message,})
          }
        })
      },
      bind_emailClick(email,email_code){//绑定邮箱
        let vm = this;
        set_email({id:vm.ids,email:email,email_code:email_code}).then(res => {
          if(res.data.code == 1){//succ
            vm.$message({type:'success', message:res.data.message,});
            vm.bind_emailVisible = false;
            vm.user_email = email;
            vm.bind_email = {};
            window.localStorage.setItem('user_email',vm.user_email);
          }else{//err
            vm.$message({type:'error', message:res.data.message,});
          }
        })
      },
      bind_PhoneClick(mobile,code){//绑定手机号
        let vm = this;
        set_mobile({id:vm.ids,mobile:mobile,sms_code:code}).then(res => {
          if(res.data.code == 1){//succ
            vm.$message({type:'success', message:res.data.message,});
            vm.bind_phoneVisible = false;
            vm.user_mobile = mobile;
            vm.bind_phone = {};
            window.localStorage.setItem('user_mobile',vm.user_mobile);
          }else{//err
            vm.$message({type:'error', message:res.data.message,});
          }
        })
      },


      goAgreenment() {
       // this.dialogRegisterVisible = false;
        this.$router.push({name: 'agreement'});
      },
      goLogin(formName) {//立即登录
        this.dialogRegisterVisible = false;
        this.dialogLoginVisible = true;
      },
      goRegister(formName) {//立即注册
        this.dialogLoginVisible = false;
        this.dialogRegisterVisible = true;
      },
      goLoginPhone(formName) {//快捷登录
        this.dialogLoginVisible = false;
        this.dialogLoginPhoneVisible = true;
      },
      goLoginPwd(formName) {//账号登录
        this.dialogLoginVisible = true;
        this.dialogLoginPhoneVisible = false;
      },
      openUserBox(isOpen){
        this.UserBox = isOpen;
      },
      logoutClick(){//退出
        logout().then(res=>{
          this.isLogin = false;
          window.localStorage.clear();
          if(this.$route.path=='/mySite'){
            this.$router.push('/home');
          }
          //this.$message({type:'success',message:res.data.message});
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .el-menu--horizontal{
    .el-menu--popup{
      .el-menu-item{
        font-family: 'pingfang' !important;
      }
    }
  }
  $height:60px;
  .item2 {
    .el-input {
      width: 62%;
    }
    .el-button--primary {
      color: #fff;
      background-color: #2f87ff;
      border:none;
      border-radius: 0;
      position: absolute;
      right: 0;
      width: 150px;
      height: 50px;
      box-sizing: border-box;
    }
    .el-button--primary.is-disabled{
      background-color:#b3b3b3 !important;
    }
  }
  .dialog_register {
    .h_title {
      height: 50px;
      line-height: 50px;
      text-align: left;
      font-size: 20px;
      color: #000000;
      margin-bottom: 15px;
    }
    /deep/ .el-dialog__header {
      padding: 0;
    }
    /deep/ .el-dialog__body {
      padding: 15px 30px 15px;
    }
    .el-form-item {
      margin-bottom: 30px;
      /deep/ .el-form-item__content {
        display: flex;
        justify-content: left;
      }
      /deep/ .el-input__inner {
        height: 50px;
        line-height: 50px;
        border: 1px solid #D8D8D8;
        border-radius: 0;
      }
    }
    .item4 {
      margin: -12px 0 10px;
      .read {
        margin-left: 5px;
        font-size: 12px;
        color: #676767;
        > a {
          color: #2F87FF;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .button_register{
      width: 100%;
      height: 50px;
      background-color: #2F87FF;
      font-size: 18px;
      color: #FFFFFF;
      border-radius: 0;
      span{
        font-size: 18px;
        color: #FFFFFF;
      }
    }
    .item_bot {
      text-align: left;
      height: 50px;
      line-height: 50px;
      > a {
        color: #2F87FF;
        &:hover {
          cursor: pointer;
        }
      }
    }
    .bot_rt {
      height: 50px;
      line-height: 50px;
      color: #2F87FF;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .fix_phone{
    .dialog-footer{
      text-align: center;
      align-items: center;
      .el-button{
        width:200px;
        border-radius: 0;
      }
    }
    /deep/ .el-dialog__header {
      padding: 0;
    }
    /deep/ .el-dialog__body {
      padding: 15px 30px 15px;
    }
    .el-form-item {
      margin-bottom: 10px;
      /deep/ .el-form-item__content {
        display: flex;
        justify-content: left;
      }
      /deep/ .el-input__inner {
        height: 40px;
        line-height: 40px;
        border: 1px solid #D8D8D8;
        border-radius: 0;
      }
    }
    .item2{
      margin:3px 0;
      /deep/ .el-form-item__label{
        display: inline-block;
        width:75px;
        text-align: left;
      }
      .el-input {
        width: 62%;
      }
    }
    .button_vCode {
      background: #2F87FF;
      border-radius: 2px;
      width: 150px;
      height: 40px;
      position: absolute;
      right: 0;
      font-size: 13px;
      color: #FFFFFF;
      >span{
        height: 40px;
        line-height: 40px;
      }
     /* &:hover {
        opacity: 0.93;
        cursor: pointer;
      }*/
    }
    .h_title{
      height: 50px;
      line-height: 50px;
      text-align: left;
      color: #000000;
      font-weight: normal;
      font-size: 18px;
    }
    .box_item{
      height:40px;
      line-height: 40px;
      text-align: left;
      >label{
        display: inline-block;
        width:70px;
      }
    }
    .wrap{
      height:40px;
      line-height:40px;
      background: #F0F0F0;
      border: 1px solid #CAC8C8;
      border-radius: 2px;
      padding:0 10px;
      .icon_info{
        color:#3FA4F8;
      }
    }
  }
  .fix_phone.fix_pwd{
    .el-form-item{
      margin:10px 0;
    }
    .el-dialog__footer{
      padding:10px 30px 30px;
    }
    .bigBtn{
      width:100%;
    }
    .item2{
      /deep/ .el-form-item__label{
        display: inline-block;
        width:82px;
        text-align: left;
      }
    }
  }
  .navBar /deep/ .mainContainer {
    .R_user {
      position: relative;
      right: -12%;
    }
    .R_Site {
      position: relative;
      right: -150px;
    }
    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }
    .el-menu--horizontal > .el-menu-item, .el-menu--horizontal > .el-submenu .el-submenu__title {
      height: $height;
      line-height: $height;
      font-size: 16px;
    }
    .user {
      color: #fff;
    }
  }

  .goNews {
    text-decoration: none;
    display: inline-block;
    width: 100%;
    height: 80px;
  }

  .navBar {
    height: $height;
    line-height: $height;
    background: #2A303B;
    font-family: 'pingfangBold';
    .gw_logo {
      width: 218px;
      height: 100%;
      margin-right: 18px;
      img {
        width: 182px;
        height: 28.3px;
      }
    }
    .gw_loginBox {
      span {
        display: inline-block;
        width: 90px;
        font-size: 16px;
        color: #fff;
        &:hover {
          cursor: pointer;
          background: #3FA4F8;
        }
      }
      .gw_register {
        background: #2F87FF;
      }
    }
    .gw_user {
      color: #fff;
      position: relative;
      .title_user{
        &:hover{
          cursor: pointer;
        }
      }
      .iconUser{
        display: inline-block;
        width:40px;
        height:40px;
        margin-right:3px;
        background:url("../assets/product.svg") -2522px -184px ;
        position: relative;
        top:14px;
      }
      .pop_user{
        width:300px;
        height:190px;
        background: #363E46;
        font-size:12px;
        position: absolute;
        right:-4px;
        ul{
          padding: 5px 10px;
        }
        li{
          height:40px;
          line-height:40px;
          box-sizing: border-box;
          .icon{
            display: inline-block;
            width:20px;
            height:18px;
          }
          .icon_mobile{
            background:url("../assets/product.svg") -2482px -221px ;
            position: relative;
            top:5px;
          }
          .icon_pwd{
            background:url("../assets/product.svg") -2482px -258px ;
            position: relative;
            top:5px;
          }
          .icon_email{
            background:url("../assets/product.svg") -2482px -293px ;
            position: relative;
            top:5px;
          }
          a{
            color:#2F87FF;
            font-size: 13px;
            &:hover{
              cursor: pointer;
            }
          }
        }
        .lastLi{
          border-top: 1px solid #616979;
          text-align: right;
          margin: 5px 0;
          padding: 8px 0;
          .return_btn{
            margin-top:5px;
            background-color:transparent;
            color:#616979;
            height:36px;
            border:1px solid #616979;
            border-radius: 0;
            &:hover{
              background:#616979;
              color:#fff;
            }
            span{
              width:100%;
              height:36px;
              text-align: center;
              line-height: 36px;
            }
          }
        }

      }
    }
  }

  .dialog {
    /*position: fixed;
    bottom: 255px;
    right: 76px;*/
    width: 100%;
    height: 180px;
    text-align: left;
    .line {
      position: relative;
      span.i_close {
        display: inline-block;
        position: absolute;
        right: -10px;
        top: -14px;
        color: #bbb;
        width: 30px;
        height: 30px;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
      > i {
        display: inline-block;
        width: 40px;
        height: 41px;
        margin-right: 5px;
      }
      .icon_phone {
        background: url("../assets/product.svg") -2296px -186px;
      }
      .icon_qq {
        background: url("../assets/product.svg") -2296px -241px;
      }
      .icon_email {
        background: url("../assets/product.svg") -2296px -296px;
      }
      .blue {
        font-size: 18px;
        color: #2F87FF;
        > a {
          display: inline-block;
          width: 100%;
          font-size: 12px;
          color: #2F87FF;
          text-decoration: none;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue